import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=cd00b0b2&scoped=true&"
import script from "./Categories.vue?vue&type=script&lang=js&"
export * from "./Categories.vue?vue&type=script&lang=js&"
import style0 from "./Categories.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Categories.vue?vue&type=style&index=1&id=cd00b0b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd00b0b2",
  null
  
)

export default component.exports